module.exports = __webpack_public_path__ + "static/media/loganMatCutter.2457709f.jpg";